<template>
    <!--弹窗-->
    <el-dialog
        width="600px"
        :title="title"
        :visible.sync="visible"
        :before-close="handleClose"
    >
        <el-form
            ref="form"
            label-width="80px"
            label-position="right"
            :rules="rules"
            :model="listData"
            class="query-form"
            size="mini"
            style="padding: 10px 0 0 20px"
        >
            <el-form-item label="日期: " class="query-form-item" prop="dateArr">
                <el-date-picker
                    v-model="listData.dateArr"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                >
                </el-date-picker>
            </el-form-item>

            <el-form-item label="Per订单数: " class="query-form-item">
                <el-input-number
                    v-model="objData.per_orders"
                    style="width: 150px;margin-left:0px;"
                    :min="0"
                    label="请输入Per订单数"
                ></el-input-number>
            </el-form-item>

            <el-form-item label="Res订单数: " class="query-form-item">
                <el-input-number
                    v-model="objData.res_orders"
                    style="width: 150px;margin-left:0px;"
                    :min="0"
                    label="请输入Res订单数"
                ></el-input-number>
            </el-form-item>

			<el-form-item label="转移: " class="query-form-item">
			    <el-checkbox v-model="objData.is_auto_transfer">转移自动</el-checkbox>
			</el-form-item>
        </el-form>
        <el-row style="margin-top:17px; ">
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                type="danger"
                plain
                @click="handleClose()"
                >取 消</el-button
            >
            <el-button
                style="float:right"
                size="mini"
                type="primary"
                @click="submitForm('formData')"
                >确定</el-button
            >
        </el-row>
    </el-dialog>
</template>
<script>
import * as api from "@/api/statistics/statistics";

export default {
    data() {
        return {
            files: [],
            dateArr: [],
            rules: {
                dateArr: [
                    {
                        required: true,
                        message: "请选择日期",
                        trigger: "blur"
                    }
                ],
                dailyBudget: [
                    {
                        required: true,
                        message: "请输入日耗值",
                        trigger: "blur"
                    }
                ],
                bidCoefficient: [
                    {
                        required: true,
                        message: "请输入bid系数",
                        trigger: "blur"
                    }
                ]
            },
            listData: {},
            objData: {
                per_orders: 0.00,
                res_orders: 0.00,
				is_auto_transfer: true
            }
        };
    },
    props: {
        formData: {
            type: Object,
            default: () => {}
        },
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        }
    },
    mounted() {
        if (this.formData.id) {
            const listData = JSON.parse(JSON.stringify(this.formData));
            listData.dateArr = [
                this.formData.start_date,
                this.formData.end_date
            ];
            this.listData = listData;
            let arr = JSON.parse(this.formData.manual_root);
            let manual_root = "";
            arr.forEach((element, index) => {
                console.log(index);
                manual_root = manual_root + element + "\n";
            });
            this.objData = {
                per_orders:this.formData.per_orders,
                res_orders:this.formData.res_orders,
				is_auto_transfer: this.formData.is_auto_transfer,
            };
        }
    },
    methods: {
        // 保存信息
        submitForm() {
            this.$refs["form"].validate(valid => {
                if (valid) {
                    if (!this.listData.dateArr.length) {
                        this.$message.warning(`请选择日期`);
                        return;
                    }
                    const loading = this.$loading({
                        lock: true,
                        text: "添加中...",
                        spinner: "el-icon-loading",
                        background: "rgba(0, 0, 0, 0.7)"
                    });
                    api.add_single_threaded_structure({
                        start_date: this.listData.dateArr[0],
                        end_date: this.listData.dateArr[1],
                        per_orders: this.objData.per_orders,
                        res_orders: this.objData.res_orders,
                        is_auto_transfer: this.objData.is_auto_transfer?1:0,
                        asin: this.$route.query.asin,
                        state: this.$route.query.state
                    })
                        .then(res => {
                            if (res.code === 0) {
                                this.$message({
                                    message: "添加成功",
                                    type: "success"
                                });
                                this.disabled = false;
                                this.handleClose(true);
                            } else {
                                this.disabled = false;
                                this.$message({
                                    message: res.message,
                                    type: "error"
                                });
                            }
                        })
                        .catch(() => {
                            this.disabled = false;
                        })
                        .finally(() => {
                            loading.close();
                        });
                } else {
                    this.loading = false;
                }
            });
        },
        // 关闭弹窗
        handleClose(isshow = false) {
            this.listData.dateArr = [];
            this.$emit("close-callback", isshow);
        }
    }
};
</script>
<style type="text/scss" lang="scss" scoped>
.download {
    display: flex;
    justify-content: center;
}
.top {
    margin: 0px auto;
    width: 60%;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
}
</style>
